import { AnalyticsConstant } from "@core/constants/analytics.constants";
import { ITenant } from "@core/interfaces/tenant.interface";
import { TUserFullInformation } from "@core/types/user-full-information.type";

import { GoogleAnalyticsService } from "ngx-google-analytics";

import { Injectable } from "@angular/core";

import { environment } from "@/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  constructor(private gaService: GoogleAnalyticsService) {}

  setUser(user: TUserFullInformation): void {
    const tenant = this.getDefaultTenant(user.tenants);

    this.gaService.gtag("config", environment.analyticsId, {
      user_id: user.userId,
    });

    this.gaService.gtag("set", "user_properties", {
      [AnalyticsConstant.USER_PROPERTIES.ROLE]: user.role,
      [AnalyticsConstant.USER_PROPERTIES.TENANT_ID]: tenant?.id ?? null,
      [AnalyticsConstant.USER_PROPERTIES.TENANT_NAME]: tenant?.name ?? null,
      [AnalyticsConstant.USER_PROPERTIES.FIRST_ACCESS]: user.firstAccess,
    });
  }

  clearUser(): void {
    this.gaService.gtag("set", "user_properties", {
      [AnalyticsConstant.USER_PROPERTIES.ROLE]: null,
      [AnalyticsConstant.USER_PROPERTIES.TENANT_ID]: null,
      [AnalyticsConstant.USER_PROPERTIES.TENANT_NAME]: null,
      [AnalyticsConstant.USER_PROPERTIES.FIRST_ACCESS]: null,
    });
  }

  trackLogin(
    role: string,
    method: string = AnalyticsConstant.VALUES.LOGIN_METHOD_CREDENTIALS,
  ): void {
    this.gaService.gtag("event", AnalyticsConstant.EVENTS.LOGIN, {
      [AnalyticsConstant.EVENT_PARAMS.METHOD]: method,
      [AnalyticsConstant.EVENT_PARAMS.USER_ROLE]: role,
    });
  }

  trackEvent(eventName: string, params?: Record<string, unknown>): void {
    this.gaService.gtag("event", eventName, params);
  }

  private getDefaultTenant(tenants: ITenant[]): ITenant | null {
    if (!tenants?.length) return null;
    return tenants.find((t) => t.defaultInstitution) ?? tenants[0];
  }
}
